class Criteria {
  constructor({
    fromDate,
    toDate,
    barberFilter,
    serviceCategoryFilter,
    productBrandFilter,
    barberId,
    brandId,
    shopId,
    shopFilter,
  }) {
    this.fromDate = fromDate;
    this.toDate = toDate;
    this.barberFilter = barberFilter;
    this.serviceCategoryFilter = serviceCategoryFilter;
    this.productBrandFilter = productBrandFilter;
    this.barberId = barberId;
    this.brandId = brandId;
    this.shopId = shopId;
    this.shopFilter = shopFilter;
  }
}

export default Criteria;
